function loadStyle() {
  // console.debug('Not implemented');
}

function loadScript(url, type, callback) {
  console.log(url, type);
  // console.log(`Loading script.. ${url}`);
  const script = document.createElement('script');
  script.type = type;
  if (script.readyState) { // IE
    script.onreadystatechange = () => {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else { // Others
    script.onload = () => {
      callback();
    };
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}

export function load(params = '', callback) {
  const formattedParams = {
    type: 'text/javascript',
  };

  if (typeof params === 'string') {
    formattedParams.url = params;
  } else if (typeof params === 'object') {
    const types = ['text/javascript', 'module'];
    const [url, type] = params;

    if (typeof url === 'string') {
      formattedParams.url = url;
    } else {
      return;
    }

    if (types.indexOf(type) > -1) {
      formattedParams.type = type;
    }
  } else {
    return;
  }

  if (formattedParams.type === 'module' && typeof window.System !== 'undefined') {
    try {
      formattedParams.urlObj = new URL(formattedParams.url);
    } catch (err) {
      if (err instanceof TypeError) {
        try {
          formattedParams.urlObj = new URL(`${window.location.protocol}${formattedParams.url}`);
        } catch (err2) {
          console.error('failed again', err2);
        }
      }
    }

    const origin = window.location.hostname.match(/local\./) !== null ? '/build' : '//cdn.joejiko.com';
    window.System.import(`${origin}${formattedParams.urlObj.pathname}`);
  }

  if (formattedParams.url.match(/\.js(\?v=[0-9]+)?$/)) {
    loadScript(formattedParams.url, formattedParams.type, callback);
  }

  if (formattedParams.url.match(/\.css(\?v=[0-9]+)?$/)) {
    loadStyle(formattedParams.url, callback);
  }
}

export default load;
